import React, { useEffect, useState } from 'react'
import Header from '../../../common/Header'
import Sidebar from '../../../common/Sidebar'
import Loader from '../../../common/Loader'
import PageHeader from '../../PageHeader'
import Footer from '../../../common/Footer'
import { formattedDateTime } from '../../../utils'
import axios from 'axios'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'

const Sheduledemo = () => {
    document.title = "SmartInvestorDeck - ManageTickets"
    const mainHeading = "Sheduled Demos";
    const selectedTabName = "Scheduleddemos";
    const heading = `Support / ${selectedTabName}`;
    const [isLoading, setIsLoading] = useState(false);
    const [demolist, setdemolist] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const navigate = useNavigate();
        const [keyword, setKeyword] = useState(null);
        const ticketView = (ticket) => {
          ///console.log(ticket);
          navigate('/support/manage_tickets/view_tickets', { state: ticket });
      }
    const getDemoList = async (size = pageSize,pageNo = pageNum) => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/apiV1/demo-tickets/?page_size=${size}&page_number=${pageNo}`);
            console.log(response);

            if (response.status == 200) {
                setdemolist(response.data.results.data);
            }
        } catch (error) {
            console.error('Error fetching demo list:', error);
        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getDemoList();
    }, []);
    const handleEdit = (row) => {
        console.log('Edit clicked', row);
        // Open dialog or navigate
      };
      
      const handleCancel = (row) => {
        console.log('Cancel clicked', row);
        // Confirm and call cancel API
      };
      
      const handleReschedule = (row) => {
        console.log('Reschedule clicked', row);
        // Open a reschedule modal with date/time picker
      };
      
    const columns = [
        {
            name: 'Name',
            selector: (row) => row.user_name,
            sortable: true,
            sortFunction: (rowA, rowB) => rowA.user_name.localeCompare(rowB.user_name),
            cell: row => <span>{row.user_name}</span>,
        },
        {
            name: 'Email',
            selector: (row) => row.created_by_email,
            sortable: true,
            sortFunction: (rowA, rowB) => rowA.created_by_email.localeCompare(rowB.created_by_email),
            cell: row => <span>{row.created_by_email}</span>,
        },
        {
            name: 'Company Name',
            selector: (row) => row.company_name,
            sortable: true,
            sortFunction: (rowA, rowB) => rowA.company_name.localeCompare(rowB.company_name),
            cell: row => <span>{row.company_name}</span>,
        },
        {
            name: 'Scheduled Date & Time',
            selector: (row) => row.demo_shedule_date,
            sortable: true,
            sortFunction: (rowA, rowB) =>
              rowA.demo_shedule_date.localeCompare(rowB.demo_shedule_date),
            cell: (row) => {
              const date = new Date(row.demo_shedule_date);
              const formatted = `${String(date.getDate()).padStart(2, '0')}-${String(
                date.getMonth() + 1
              ).padStart(2, '0')}-${date.getFullYear()} ${String(
                date.getHours()
              ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
              ).padStart(2, '0')}`;
          
              return <span>{formatted}</span>;
            },
          },
          
        {
            name: 'TimeZone',
            selector: (row) => row.demo_shedule_time_zone,
            sortable: true,
            sortFunction: (rowA, rowB) => rowA.demo_shedule_time_zone.localeCompare(rowB.demo_shedule_time_zone),
            cell: row => <span>{row.demo_shedule_time_zone}</span>,
        },
        // {
        //     name: 'Category',
        //     selector: (row) => row.ticket_category,
        //     sortable: true,
        //     cell: row => <span style={{ color: 'blue', cursor: 'pointer' }} >{row.ticket_category}</span>,
        // },
        // {
        //     name: 'Sub Category',
        //     selector: (row) => row.ticket_sub_category,
        //     sortable: true,
        //     cell: row => <span style={{ color: 'blue', cursor: 'pointer' }} >{row.ticket_sub_category}</span>,
        // },
        // {
        //     name: 'Assigned User',
        //     selector: (row) => row.assigned_user,
        //     sortable: true,
        //     cell: row => <span style={{ color: 'blue', cursor: 'pointer' }}>{row.assigned_user}</span>,
        // },
        {
            name: 'Time Span',
            selector: (row) => row.time_span,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Status',
            selector: (row) => row.ticket_status_value,
            // sortable: true,
            width: '150px',
            cell: row => <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => ticketView(row)}>{row.ticket_status_value === 'Pending' ? 'In progress' : row.ticket_status_value}</span>,
        },
        // {
        //     name: 'Actions',
        //     selector: (row) => row.ticket_status_value,
        //     cell: (row) => (
        //       <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        //         <button
        //         title='Edit'
        //           style={{
        //             padding: '4px 8px',
        //             fontSize: '0.75rem',
        //             backgroundColor: '#1976d2',
        //             color: '#fff',
        //             border: 'none',
        //             borderRadius: '4px',
        //             cursor: 'pointer'
        //           }}
        //           onClick={() => handleEdit(row)}
        //         >
        //           <i className="bx bx-pencil"></i>
        //         </button>
        //         <button
        //         title='Cancel'
        //           style={{
        //             padding: '4px 8px',
        //             fontSize: '0.75rem',
        //             backgroundColor: '#d32f2f',
        //             color: '#fff',
        //             border: 'none',
        //             borderRadius: '4px',
        //             cursor: 'pointer'
        //           }}
        //           onClick={() => handleCancel(row)}
        //         >
        //            <i className="bx bx-x-circle"></i>
        //         </button>
        //         <button
        //         title='Reschedule'
        //           style={{
        //             padding: '4px 8px',
        //             fontSize: '0.75rem',
        //             backgroundColor: '#ffa000',
        //             color: '#fff',
        //             border: 'none',
        //             borderRadius: '4px',
        //             cursor: 'pointer'
        //           }}
        //           onClick={() => handleReschedule(row)}
        //         >
        //           <i className="bx bx-calendar-edit"></i>
        //         </button>
        //       </div>
        //     )
        //   }
          
        // {
        //     name: 'Created At',
        //     selector: (row) => row.register_date,
        //     sortable: true,
        //     cell: row => formattedDateTime(row.register_date),
        // },
        // {
        //     name: 'Updated At',
        //     selector: (row) => row.updated_date,
        //     sortable: true,
        //     cell: row => formattedDateTime(row.updated_date),

        // },
        // {
        //     name: 'Created By',
        //     selector: (row) => row.created_by_name,
        //     cell: row => (row.created_by_name),
        //     sortable: true,
        // },
        // {
        //     name: 'Updated By',
        //     selector: (row) => row.updated_by_name,
        //     cell: row => (row.updated_by_name),
        //     sortable: true,
        // },

    ];
    const paginationComponentOptions = {

        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    const handlePerRowsChange = async (page, newPerPage) => {
        console.log("page", page, "newPerPage", newPerPage);

        getDemoList(page, newPerPage, keyword);
        setPageSize(page);
        setPageNum(newPerPage);
    };
    const handlePageChange = (page) => {
        setPageSize(10)
        setPageNum(page);
    };
    return (
        <div>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <div className="main-content">
                    {isLoading ? <div className='loader-overlay text-white'>
                        <Loader />
                    </div> : ""}
                    <div className="page-content" style={{ backgroundColor: "#ededed" }}>
                        <div className="container-fluid" style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", padding: "15px", borderRadius: "10px", marginBottom: "10px", backgroundColor: "#fff" }}>
                            <PageHeader mainHeading={mainHeading} heading={heading} />
                            <DataTable
                                columns={columns}
                                data={demolist}
                                // paginationTotalRows={totalitemCount}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                paginationDefaultPage={pageNum}
                                paginationServer
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                fixedHeaderScrollHeight='600px'
                                fixedHeader
                                persistTableHead
                                sortServer
                                // onSort={handleSort}
                                noDataComponent={<div className="text-center">No data available</div>}
                            />
                        </div>
                    </div>
                    <Footer />
                </div>

            </div>
            <div className="rightbar-overlay"></div>
        </div>
    )
}

export default Sheduledemo
